/* eslint-disable max-len */
import React from 'react';
import { AllieIconProps } from '../../..';

export const FactoryGptMenuSelectedMobileApp = (props: AllieIconProps) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19 11.25C19.4142 11.25 19.75 11.5858 19.75 12C19.75 14.3891 20.2624 15.8973 21.195 16.8238C22.1286 17.7513 23.6382 18.25 26 18.25C26.4142 18.25 26.75 18.5858 26.75 19C26.75 19.4142 26.4142 19.75 26 19.75C23.6432 19.75 22.1322 20.2613 21.1967 21.1967C20.2613 22.1322 19.75 23.6432 19.75 26C19.75 26.4142 19.4142 26.75 19 26.75C18.5858 26.75 18.25 26.4142 18.25 26C18.25 23.6444 17.7356 22.1331 16.7981 21.1972C15.8604 20.261 14.3488 19.75 12 19.75C11.5858 19.75 11.25 19.4142 11.25 19C11.25 18.5858 11.5858 18.25 12 18.25C14.3538 18.25 15.864 17.7516 16.7999 16.8234C17.7345 15.8964 18.25 14.3878 18.25 12C18.25 11.5858 18.5858 11.25 19 11.25Z"
        fill={props.color || '#131316'}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.5 5.25C10.9142 5.25 11.25 5.58579 11.25 6C11.25 7.5053 11.574 8.38855 12.0998 8.91101C12.6267 9.43446 13.5113 9.75 15 9.75C15.4142 9.75 15.75 10.0858 15.75 10.5C15.75 10.9142 15.4142 11.25 15 11.25C13.5163 11.25 12.6303 11.5729 12.1016 12.1016C11.5729 12.6303 11.25 13.5163 11.25 15C11.25 15.4142 10.9142 15.75 10.5 15.75C10.0858 15.75 9.75 15.4142 9.75 15C9.75 13.5176 9.42532 12.6312 8.89526 12.102C8.36496 11.5726 7.47828 11.25 6 11.25C5.58579 11.25 5.25 10.9142 5.25 10.5C5.25 10.0858 5.58579 9.75 6 9.75C7.48328 9.75 8.36854 9.43473 8.897 8.91058C9.42421 8.38766 9.75 7.50405 9.75 6C9.75 5.58579 10.0858 5.25 10.5 5.25Z"
        fill={props.color || '#131316'}
      />
    </svg>
  );
};
